const state = {
}

const getters = {}

const actions = {
  getPatientByIdMobileName ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/dispensary/patient-search", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  createNewPatient({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/dispensary/patient/addPatient", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },

}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
